import Vue from 'vue';
import Router from 'vue-router';
import Intro from '@/components/Intro.vue';
import BeforeEnter from '@/components/BeforeEnter.vue';
import Born from '@/components/Born.vue';
import Smog from '@/components/Smog.vue';
import Meteo from '@/components/Meteo.vue';
import Heat from '@/components/Heat.vue';
import Death from '@/components/Death.vue';
import Prelude from '@/components/Prelude.vue';
import APropos from '@/components/APropos.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: "/",
  routes: [
    {
      path: "/",
      name: 'Intro',
      component: Intro,
    },
    {
      path: "/before-enter",
      name: 'BeforeEnterEN',
      component: BeforeEnter,
    },
    {
      path: "/avant-d-entrer",
      name: 'BeforeEnterFR',
      component: BeforeEnter,
    },
    {
      path: "/prelude",
      name: 'Prelude',
      component: Prelude,
    },
    {
      path: "/born",
      name: 'BornEN',
      component: Born,
    },
    {
      path: '/naissance',
      name: 'BornFR',
      component: Born,
    },
    {
      path: "/smog",
      name: 'SmogEN',
      component: Smog,
    },
    {
      path: "/pollution",
      name: 'SmogFR',
      component: Smog,
    },
    {
      path: "/meteo",
      name: 'MeteoFR',
      component: Meteo,
    },
    {
      path: "/meteo",
      name: 'MeteoEN',
      component: Meteo,
    },
    {
      path: "/heat",
      name: 'HeatEN',
      component: Heat,
    },
    {
      path: "/canicule",
      name: 'HeatFR',
      component: Heat,
    },
    {
      path: "/death",
      name: 'DeathEN',
      component: Death,
    },
    {
      path: "/mort",
      name: 'DeathFR',
      component: Death,
    },
    {
      path: "/a-propos",
      name: 'AboutFR',
      component: APropos,
    },
    {
      path: "/about",
      name: 'AboutEN',
      component: APropos,
    },
  ]
});


router.beforeEach((to, from, next) => {

  if(!from.name && to.name != 'Intro') {
    next({name: 'Intro'});
    return;
  }

  next();

});

export default router;
